import { User, AuthResponse, AuthError } from "@supabase/supabase-js";
import { DatabaseManager } from "@/lib/database/DatabaseManager.client";
import {
  getCurrentUser,
  requireCurrentUser,
  updateUser,
  setPassword,
} from "./AuthManager.shared";
import { IAuthManager } from "./IAuthManager";

export class AuthManager implements IAuthManager {
  private client: ReturnType<typeof DatabaseManager.createBrowserClient>;

  constructor() {
    this.client = DatabaseManager.createBrowserClient();
  }

  async getCurrentUser(): Promise<User | null> {
    return getCurrentUser(this.client);
  }

  async requireCurrentUser(): Promise<User> {
    return requireCurrentUser(this.client);
  }

  async signInWithPassword(
    email: string,
    password: string
  ): Promise<AuthResponse> {
    return this.client.auth.signInWithPassword({ email, password });
  }

  async signOut(): Promise<{ error: AuthError | null }> {
    return this.client.auth.signOut();
  }

  async updateUser(
    userId: string,
    updates: Record<string, any>
  ): Promise<{ data: { user: User | null } | null; error: AuthError | null }> {
    return await updateUser(this.client, userId, updates);
  }

  async setPassword(
    userId: string,
    newPassword: string
  ): Promise<{ data: { user: User | null } | null; error: AuthError | null }> {
    return await setPassword(this.client, userId, newPassword);
  }

  async createUserWithPassword(
    email: string,
    password: string
  ): Promise<{ data: { user: User | null } | null; error: AuthError | null }> {
    // Client-side stub - this should not be called on the client
    throw new Error(
      "createUserWithPassword is not available on the client side"
    );
  }

  async getUserById(userId: string): Promise<User | null> {
    // Client-side stub - this should not be called on the client
    throw new Error("getUserById is not available on the client side");
  }

  async deleteUser(userId: string): Promise<boolean> {
    // Client-side stub - this should not be called on the client
    throw new Error("deleteUser is not available on the client side");
  }
}
